var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.settings)?_c('Settings',{attrs:{"settings":_vm.settings,"active-tab":_vm.activeTab},on:{"updateSettings":_vm.update}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }